import { MIN_PEAK_COUNT, PEAK_COUNT } from "@vault/shared/media";

export const columnsFor = (frames: number): number => {
  if (!Number.isFinite(frames)) return 0;
  const whole = Math.floor(frames);
  return whole < MIN_PEAK_COUNT ? 0 : Math.min(PEAK_COUNT, whole);
};

export const peakByte = (value: number): number =>
  Math.round(Math.min(1, Math.max(0, value)) * 255);

export type PeakBins = {
  readonly columns: number;
  add: (frame: number, value: number) => void;
  bytes: () => Uint8Array<ArrayBuffer>;
};

export const createBins = (frames: number, columns = columnsFor(frames)): PeakBins => {
  const maxima = new Float32Array(Math.max(0, columns));
  const span = Math.max(1, Math.floor(frames));
  const last = columns - 1;
  return {
    columns,
    add(frame, value) {
      if (columns === 0 || !(value > 0)) return;
      const index = Math.min(last, Math.max(0, Math.floor((frame * columns) / span)));
      if (value > (maxima[index] ?? 0)) maxima[index] = value;
    },
    bytes: () => Uint8Array.from(maxima, peakByte),
  };
};
